import React, { useEffect, useState } from "react";
import { Button } from "antd";
import Main from "../../components/layout/Main";
import GamesImage from "../../assets/images/games-image.jpg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import CommonBreadcrumb from "../../components/BreadCrumb";
import { useTournament } from "../../context/TournamentContext";
import { getDiff, isValidUrl } from "../../helper/functions";
import moment from "moment";
import { ImageNotAvailable } from "../../constants/urls";
import { useAuth } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";

// ------ match url tournament is live , past or upcoming -------
const statusMap = {
  live: "Active",
  past: "Completed",
  upcoming: "Upcoming",
};

const SelectedGameDetail = () => {
  const [tournaments, setTournaments] = useState([]);
  const [profile, setProfile] = useState();
  const { getProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { loadTournaments, filters, updateFilters } = useTournament();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const pastUrl = location.pathname;
  const tournament = pastUrl.split("/")[1];
  const tournamentType = tournament.split("-")[0];

  const game = decodeURIComponent(pastUrl.split("/")[3]);
  // ----------   handlers   -----------
  const fetchTournaments = async () => {
    const profileData = await getProfile();
    if (profileData.status === 200) {
      setProfile(profileData.data);
    }

    const response = await loadTournaments();
    if (response.status === 200) {
      setTournaments(response.data.data.tournaments);
    }
  };
  // console.log("tournament ====>", tournament);
  // ---------- use effects ----------
  useEffect(() => {
    updateFilters({
      status: tab,
      type: tournamentType == "private" ? "private" : " public",
      game: game,
    });
  }, []);

  useEffect(() => {
    fetchTournaments();
  }, [filters, tournament, game]);
  return (
    <Main>
      <CommonBreadcrumb
        items={[
          { title: "Home", url: "/home" },
          { title: "Games", url: `/${tournament}/games` },
          { title: game },
        ]}
      />

      <div className="section-headding">
        {/* Show here version if have */}
        <h6>{game}</h6>
        <div className="create-btn-header">
          <Button
            className="private-tunament-button Fill-button"
            onClick={() => {
              if (profile.isSubscribed) {
                navigate("/create-private-tournament");
              } else {
                ShowToast(
                  "You can't create private tournament. Kindly subscribe our plan",
                  Severty.ERROR
                );
              }
            }}
          >
            Create Private Tournament
          </Button>
        </div>
      </div>
      <div className="home-container">
        {/* Active Tournaments */}
        {tab === "Active" && (
          <div className="main-grid-class">
            {tournaments && tournaments.length > 0 ? (
              tournaments.map((item, index) => (
                <div key={index} className="tournament-card">
                  <div className="tunament-image">
                    <img
                      alt="thumbnail"
                      src={
                        isValidUrl(item.game.image)
                          ? item?.game?.image
                          : ImageNotAvailable
                      }
                    />
                  </div>

                  <div className="card-top-info">
                    <div className="tunament-date">
                      {moment(item.startDate).format("DD MMM YYYY | HH:mm A")}
                    </div>
                    <div className="starts-time">
                      <span>{getDiff(item.startDate, new Date())}</span>
                    </div>
                  </div>
                  <div className="card-tags">
                    {/* <img src={TrofiesImage} alt="Trophies" /> */}
                    <span>{item.name_en}</span>
                  </div>

                  <div className="card-tags-item1">
                    <img src={TrofiesImage} alt="Trophies" />
                    {item &&
                      item?.trophyStructure?.map((trophy, index) => (
                        <span>{trophy}</span>
                      ))}
                  </div>

                  <div className="tunament-slot">{`${
                    item.totalRegisteredPlayers
                  }/ ${
                    item?.teamSize *
                    (item.totalPlayerSize > 0 ? item.totalPlayerSize : 1)
                  } slots`}</div>

                  <div className="brouse-game-live-btn">
                    {/* ❌ NOT SUBSCRIBED → Show only Subscribe button */}
                    {!profile?.isSubscribed && (
                      <>
                        <Button
                          className="join-button Fill-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/subscriptions");
                          }}
                        >
                          Upgrade To Premium
                        </Button>
                      </>
                    )}

                    {/* ✅ SUBSCRIBED → Show normal tournament buttons */}
                    {profile?.isSubscribed && (
                      <>
                        {/* Creator & NO bracket → Create Bracket */}
                        {item.isCreator && !item.bracketGenerated && (
                          <Button
                            className="bid-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/private-tournaments/create-bracket/${item._id}`
                              );
                            }}
                          >
                            Create Bracket
                          </Button>
                        )}

                        {/* Creator & bracket generated → Brackets */}
                        {item.isCreator && item.bracketGenerated && (
                          <Button
                            className="bid-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/private-tournaments/brackets/${item._id}`
                              );
                            }}
                          >
                            Brackets
                          </Button>
                        )}

                        {/* Not creator → View Bracket */}
                        {!item.isCreator && (
                          <Button
                            className="bid-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            View Bracket
                          </Button>
                        )}

                        {/* Not creator → Join Tournament */}
                        {!item.isCreator && (
                          <Button
                            className="join-button Fill-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            Join Tournament
                          </Button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p className="private-tournamnet-no-data-found-text">
                No Private Tournaments Found
              </p>
            )}
          </div>
        )}
        {/* Upcoming Tournaments */}
        {tab === "Upcoming" && (
          <div className="main-grid-class">
            {tournaments && tournaments.length > 0 ? (
              tournaments.map((item, index) => (
                <div key={index} className="tournament-card">
                  <div className="tunament-image">
                    <img
                      alt="thumbnail"
                      src={
                        isValidUrl(item.game.image)
                          ? item?.game?.image
                          : ImageNotAvailable
                      }
                    />
                  </div>

                  <div className="card-top-info">
                    <div className="tunament-date">
                      {moment(item.startDate).format("DD MMM YYYY | HH:mm A")}
                    </div>
                    <div className="starts-time">
                      <span>{getDiff(item.startDate, new Date())}</span>
                    </div>
                  </div>
                  <div className="card-tags">
                    {/* <img src={TrofiesImage} alt="Trophies" /> */}
                    <span>{item.name_en}</span>
                  </div>

                  <div className="card-tags-item1">
                    <img src={TrofiesImage} alt="Trophies" />
                    {item &&
                      item?.trophyStructure?.map((trophy, index) => (
                        <span>{trophy}</span>
                      ))}
                  </div>

                  <div className="tunament-slot">{`${
                    item.totalRegisteredPlayers
                  }/ ${
                    item?.teamSize *
                    (item.totalPlayerSize > 0 ? item.totalPlayerSize : 1)
                  } slots`}</div>

                  {/* <div className="tunament-slot">{item.status}</div> */}

                  <div className="brouse-game-live-btn">
                    {/* ❌ NOT SUBSCRIBED → Show only Subscribe button */}
                    {!profile?.isSubscribed && (
                      <>
                        <Button
                          className="join-button Fill-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/subscriptions");
                          }}
                        >
                          Upgrade To Premium
                        </Button>
                        {tab === "Upcoming" && (
                          <Button
                            className="join-button Fill-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            Play via token
                          </Button>
                        )}
                      </>
                    )}

                    {/* ✅ SUBSCRIBED → Show normal tournament buttons */}
                    {profile?.isSubscribed && (
                      <>
                        {/* Creator & NO bracket → Create Bracket */}
                        {item.isCreator && !item.bracketGenerated && (
                          <Button
                            className="bid-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/private-tournaments/create-bracket/${item._id}`
                              );
                            }}
                          >
                            Create Bracket
                          </Button>
                        )}

                        {/* Creator & bracket generated → Brackets */}
                        {item.isCreator && item.bracketGenerated && (
                          <Button
                            className="bid-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/private-tournaments/brackets/${item._id}`
                              );
                            }}
                          >
                            Brackets
                          </Button>
                        )}

                        {/* Not creator → View Bracket */}
                        {!item.isCreator && (
                          <Button
                            className="bid-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            View Bracket
                          </Button>
                        )}

                        {/* Not creator → Join Tournament */}
                        {!item.isCreator && (
                          <Button
                            className="join-button Fill-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            Join Tournament
                          </Button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p className="private-tournamnet-no-data-found-text">
                No Private Tournaments Found
              </p>
            )}
          </div>
        )}
        {/* Past Tournaments */}
        {tab === "Completed" && (
          <div className="main-grid-class">
            {tournaments && tournaments.length > 0 ? (
              tournaments.map((item, index) => {
                return (
                  <div key={index} className="tournament-card">
                    <div className="tunament-image">
                      <img
                        alt="thumbnail"
                        src={
                          isValidUrl(item?.game?.image)
                            ? item?.game?.image
                            : ImageNotAvailable
                        }
                      />
                    </div>

                    <div className="card-top-info">
                      <div className="tunament-date">
                        {moment(item.startDate).format("DD MMM YYYY | HH:mm A")}
                      </div>
                      <div className="tunament-date">Public</div>
                    </div>

                    <div className="card-tags">
                      <img src={TrofiesImage} alt="Trophies" />
                      <span>{item.name_en}</span>
                    </div>

                    <div className="tunament-slot">{`${
                      item.totalRegisteredPlayers
                    }/ ${
                      item?.teamSize *
                      (item.totalPlayerSize > 0 ? item.totalPlayerSize : 1)
                    } slots`}</div>

                    <div className="brouse-game-live-btn">
                      {profile?.isSubscribed ? (
                        <Button
                          className="bid-button"
                          onClick={() =>
                            navigate(
                              `/past-tournaments/tournament-result/${item._id}`
                            )
                          }
                        >
                          View Results
                        </Button>
                      ) : (
                        <Button
                          className="join-button Fill-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/subscriptions");
                          }}
                        >
                          Upgrade To Premium
                        </Button>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No past tournaments found</p>
            )}
          </div>
        )}
      </div>
    </Main>
  );
};

export default SelectedGameDetail;
